import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Logger from "../utils/logger";

const log = Logger.create("ScrollToTop");

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // or "auto" for instant
  }, [pathname]);

  return null;
}
